import Pusher from 'pusher-js'

const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
  cluster: 'eu',
  encrypted: true,
})

export const Subscribe = async ({ channel_token }, dispatch) => {
  const channel = pusher.subscribe(channel_token)
  channel.bind('status', status => dispatch({ type: 'modify operation', payload: { ...status } }))
}
